module.exports = __webpack_public_path__ + "static/media/21-11.0a4660c6.mp3";